import { bffRequestV3 } from '@/app/bffClient';
import { getApiV3CustomersByCustomerIdNotifications } from 'bff-api/mitt-malarenergi/v3';

export interface InfoMessage {
  active?: boolean;
  title: string;
  content: string;
  displayLocation: string;
  targetAudience: string;
  targetSystem: string;
  type: 'info' | 'warning' | 'error';
  startDate?: string;
  endDate?: string;
  link?: {
    text: string;
    url: string;
  };
}

export interface PowerHubMessage {
  _id: string;
  title: string;
  price: number;
  content: Array<{
    _key: string;
    _type: 'block';
    children: Array<{
      _key: string;
      _type: 'span';
      marks: string[];
      text: string;
    }>;
    markDefs: any[];
    style: string;
  }>;
}

export interface NotificationsResponse {
  alerts: InfoMessage[];
  powerHubMessages: PowerHubMessage[];
  unreadMessageCount?: number;
}

export const fetchInfoMessages = async (
  customerId: number,
): Promise<NotificationsResponse> => {
  try {
    const envelope = await bffRequestV3((client) =>
      getApiV3CustomersByCustomerIdNotifications({
        client,
        path: { customerId },
        throwOnError: true,
      }),
    );
    const data = envelope.data?.[0];
    return {
      alerts: Array.isArray(data?.alerts) ? (data.alerts as InfoMessage[]) : [],
      powerHubMessages: Array.isArray(data?.powerHubMessages)
        ? (data.powerHubMessages as PowerHubMessage[])
        : [],
      unreadMessageCount:
        typeof data?.unreadMessageCount === 'number'
          ? data.unreadMessageCount
          : 0,
    };
  } catch (error) {
    console.error('Failed to fetch info messages:', error);
    return { alerts: [], powerHubMessages: [], unreadMessageCount: 0 };
  }
};

